import NetsuiteEmbeddedSetup from "../netsuite/EmbeddedSetup";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import LinkComplete from "../LinkComplete";
import LinkContainer from "../LinkContainer";
import LinkError from "../LinkError";
import CompanySelect from "../accounting/CompanySelect";
import EnvironmentSelect from "../accounting/EnvironmentSelect";
import GenericBankFeedsLink from "../accounting/bankFeeds/GenericBankFeedsLink";
import BankFeedsAuth from "../accounting/genericBankFeeds/BankFeedsAuth";
import BankFeedsCancelled from "../accounting/genericBankFeeds/BankFeedsCancelled";
import BankFeedsConsent from "../accounting/genericBankFeeds/BankFeedsConsent";
import BankFeedsError from "../accounting/genericBankFeeds/BankFeedsError";
import BankFeedsFakeLogin from "../accounting/genericBankFeeds/BankFeedsFakeLogin";
import IntuitBankFeedsAuth from "../accounting/intuitBankFeeds/IntuitBankFeedsAuth";
import IntuitBankFeedsConsent from "../accounting/intuitBankFeeds/IntuitBankFeedsConsent";
import IntuitBankFeedsError from "../accounting/intuitBankFeeds/IntuitBankFeedsError";
import IntuitBankFeedsExtraFakeLogin from "../accounting/intuitBankFeeds/IntuitBankFeedsExtraFakeLogin";
import IntuitBankFeedsRedirect from "../accounting/intuitBankFeeds/IntuitBankFeedsRedirect";
import IntuitBankFeedsSuccess from "../accounting/intuitBankFeeds/IntuitBankFeedsSuccess";
import PlaidBankFeedsError from "../accounting/plaid/PlaidBankFeedsError";
import PlaidBankFeedsRedirect from "../accounting/plaid/PlaidBankFeedsRedirect";
import PlaidBankFeedsSuccess from "../accounting/plaid/PlaidBankFeedsSuccess";
import SageBankFeedsAuth from "../accounting/sageBankFeeds/SageBankFeedsAuth";
import SageBankFeedsError from "../accounting/sageBankFeeds/SageBankFeedsError";
import SageBankFeedsFakeLogin from "../accounting/sageBankFeeds/SageBankFeedsFakeLogin";
import SageBankFeedsRedirect from "../accounting/sageBankFeeds/SageBankFeedsRedirect";
import SageBankFeedsSuccess from "../accounting/sageBankFeeds/SageBankFeedsSuccess";
import YodleeBankFeedsRedirect from "../accounting/yodlee/YodleeBankFeedsRedirect";
import YodleeBankFeedsSuccess from "../accounting/yodlee/YodleeBankFeedsSuccess";
import BigCommerceComplete from "../bigcommerce/LinkComplete";
import MerchantAuth from "../browserbase/MerchantAuth";
import PaymentMethod from "../browserbase/PaymentMethod";
import CapitalOneDataPage from "../capitalone/CapitalOneDataPage";
import { DevTools } from "../components/DevTools";
import ConnectionContainer from "../container/ConnectionContainer";
import UpdateComplete from "../container/UpdateComplete";
import SubsidiarySelect from "../netsuite/SubsidiarySelect";
import ShopifyCustomAppComplete from "../shopify/CustomAppLinkComplete";
import SandboxFakeAuth from "../stores/shared/SandboxFakeAuth";
import { UploadCustomerSpend } from "../supplierEnablement/customerSpend/UploadCustomerSpend";
import { STORES } from "../utils";
import WooCommerceComplete from "../woocommerce/LinkComplete";

export default function MainContainer() {
  return (
    <Router>
      <DevTools />
      <Switch>
        <Route
          exact
          path="/netsuite/embedded-setup"
          component={NetsuiteEmbeddedSetup}
        />
        <Route exact path="/complete">
          <LinkComplete></LinkComplete>
        </Route>
        <Route exact path="/updatecomplete">
          <UpdateComplete></UpdateComplete>
        </Route>
        <Route exact path="/bigcommercecomplete">
          <BigCommerceComplete></BigCommerceComplete>
        </Route>
        <Route exact path="/shopifycustomcomplete">
          <ShopifyCustomAppComplete></ShopifyCustomAppComplete>
        </Route>
        <Route exact path="/woocommercecomplete">
          <WooCommerceComplete></WooCommerceComplete>
        </Route>
        <Route exact path="/dynamicsenvironmentselect">
          <EnvironmentSelect platform={STORES.DYNAMICS365}></EnvironmentSelect>
        </Route>
        <Route exact path="/dynamicscompanyselect">
          <CompanySelect platform={STORES.DYNAMICS365}></CompanySelect>
        </Route>
        <Route exact path="/netsuitesubsidiaryselect">
          <SubsidiarySelect></SubsidiarySelect>
        </Route>
        <Route exact path="/zohobookscompanyselect">
          <CompanySelect platform={STORES.ZOHOBOOKS}></CompanySelect>
        </Route>
        <Route exact path="/anfixcompanyselect">
          <CompanySelect platform={STORES.ANFIX}></CompanySelect>
        </Route>
        <Route exact path="/sandboxauth">
          <SandboxFakeAuth></SandboxFakeAuth>
        </Route>
        <Route
          exact
          path="/sage_bank_feeds_auth"
          component={SageBankFeedsAuth}
        />
        <Route
          exact
          path="/sage_bank_feeds_cancelled"
          component={BankFeedsCancelled}
        />
        <Route
          exact
          path="/sage_bank_feeds_fake_login"
          component={SageBankFeedsFakeLogin}
        />
        <Route
          exact
          path="/sage_bank_feeds_redirect"
          component={SageBankFeedsRedirect}
        />
        <Route
          exact
          path="/sage_bank_feeds_success"
          component={SageBankFeedsSuccess}
        />
        <Route
          exact
          path="/sage_bank_feeds_error"
          component={SageBankFeedsError}
        />
        <Route exact path="/bank_feeds_auth" component={BankFeedsAuth} />
        <Route
          exact
          path="/intuit_bank_feeds_auth"
          component={IntuitBankFeedsAuth}
        />
        <Route
          exact
          path="/bank_feeds_cancelled"
          component={BankFeedsCancelled}
        />
        <Route
          exact
          path="/intuit_bank_feeds_fake_login"
          component={BankFeedsFakeLogin}
        />
        <Route
          exact
          path="/intuit_bank_feeds_extra_fake_login"
          component={IntuitBankFeedsExtraFakeLogin}
        />
        <Route
          exact
          path="/intuit_bank_feeds_redirect"
          component={IntuitBankFeedsRedirect}
        />
        <Route
          exact
          path="/intuit_bank_feeds_consent"
          component={IntuitBankFeedsConsent}
        />
        <Route exact path="/bank_feeds_consent" component={BankFeedsConsent} />
        <Route exact path="/bank_feeds_error" component={BankFeedsError} />
        <Route
          exact
          path="/intuit_bank_feeds_success"
          component={IntuitBankFeedsSuccess}
        />
        <Route
          exact
          path="/intuit_bank_feeds_cancelled"
          component={BankFeedsCancelled}
        />
        <Route
          exact
          path="/intuit_bank_feeds_error"
          component={IntuitBankFeedsError}
        />
        <Route
          exact
          path="/plaid_bank_feeds_fake_login"
          component={BankFeedsFakeLogin}
        />
        <Route
          exact
          path="/plaid_bank_feeds_redirect"
          component={PlaidBankFeedsRedirect}
        />
        <Route
          exact
          path="/plaid_bank_feeds_success"
          component={PlaidBankFeedsSuccess}
        />
        <Route
          exact
          path="/plaid_bank_feeds_error"
          component={PlaidBankFeedsError}
        />
        <Route
          exact
          path="/bank_feeds_fake_login"
          component={BankFeedsFakeLogin}
        />
        <Route
          exact
          path="/yodlee_bank_feeds_redirect"
          component={YodleeBankFeedsRedirect}
        />
        <Route
          exact
          path="/yodlee_bank_feeds_success"
          component={YodleeBankFeedsSuccess}
        />
        <Route
          exact
          path="/bank_feeds_fake_login"
          component={BankFeedsFakeLogin}
        />
        <Route exact path="/bank_feeds_link" component={GenericBankFeedsLink} />
        <Route exact path="/capitalonedata">
          <CapitalOneDataPage></CapitalOneDataPage>
        </Route>
        <Route exact path="/merchant_auth/:id">
          <MerchantAuth></MerchantAuth>
        </Route>
        <Route exact path="/payment_method/:id">
          <PaymentMethod></PaymentMethod>
        </Route>
        <Route exact path="/error">
          <LinkError></LinkError>
        </Route>
        <Route path="/connection/:id/upload-spend">
          <UploadCustomerSpend />
        </Route>
        <Route path="/connection/:id">
          <ConnectionContainer></ConnectionContainer>
        </Route>
        <Route path="/connections/:id">
          <ConnectionContainer></ConnectionContainer>
        </Route>
        <Route>
          <LinkContainer></LinkContainer>
        </Route>
      </Switch>
    </Router>
  );
}
